import { Role } from 'generated/graphql';
import { clientRequestsStatuses, requestsStatuses } from 'utils/helpers/lists/requestsStatuses';

export const getStatusRu = (status: string | null, meRole?: string) => {
  const requestStatusesOptionsFn =
    meRole === Role.ClientDirector || meRole === Role.ClientManager ? clientRequestsStatuses : requestsStatuses;
  const requestStatusesOptions = requestStatusesOptionsFn.map(el => ({ status: el.id, statusRu: el.name }));
  return requestStatusesOptions.find(item => status === item.status)?.statusRu;
};
